import _ from 'lodash';

import { Component } from 'react';

import { firearm_ty_name, firearm_ty_name_short } from './presets_firearm.mjs';
import { gears_vest_bulletproof } from './presets_gear';
import { L } from './localization.mjs';

export class GearView extends Component {
  render() {
    const { gear: g, prev_gear: prev_g } = this.props;

    let vest_hit_prob_text = 'loc_ui_string_common_compare_protection_coverage_veryhigh'
    if (g.vest_hit_prob < 0.75) {
      vest_hit_prob_text = 'loc_ui_string_common_compare_protection_coverage_low'
    }
    else if (g.vest_hit_prob < 0.85) {
      vest_hit_prob_text = 'loc_ui_string_common_compare_protection_coverage_adequate'
    }
    else if (g.vest_hit_prob < 0.95) {
      vest_hit_prob_text = 'loc_ui_string_common_compare_protection_coverage_high'
    }

    const getCompareText = (diff) => {
      if (diff > 0) {
        return <>(<font className='item-arrow-higher'>{L('loc_dynamic_string_common_item_compare_higher')}</font>)</>;
      }
      else if (diff < 0) {
        return <>(<font className='item-arrow-lower'>{L('loc_dynamic_string_common_item_compare_lower')}</font>)</>
      }
      else {
        return <>({L('loc_dynamic_string_common_item_compare_equal')})</>;
      }
    }

    let armor_diff = null;
    let vest_hit_prob_diff = null;

    if (prev_g) {
      armor_diff = getCompareText(g.vest_armor - prev_g.vest_armor);
      vest_hit_prob_diff = getCompareText((g.vest_hit_prob - prev_g.vest_hit_prob).toFixed(2));
    }

    return <table>
      <tbody>
        <tr>
          <td>{L('loc_ui_string_common_compare_name')}</td>
          <td>{L(g.vest_name)}</td>
        </tr>

        <tr>
          <td>{L('loc_ui_string_common_compare_protection_tier')}</td>
          <td>{L('loc_dynamic_string_common_item_tier')}{g.vest_rate}</td>
        </tr>

        <tr>
          <td>{L('loc_ui_string_common_compare_protection_durability')}</td>
          <td>{g.vest_armor}{armor_diff}</td>
        </tr>

        <tr>
          <td>{L('loc_ui_string_common_compare_protection_coverage')}</td>
          <td>{L('vest_hit_prob_text')}{vest_hit_prob_diff}</td>
        </tr>
      </tbody>
    </table>;
  }
}

export class GearsView extends Component {
  render() {
    let rows = [];

    rows.push(<tr>
      {gears_vest_bulletproof.map((gear, i) => {
        return <td key={i}>
          <GearView gear={gear} prev_gear={gears_vest_bulletproof[2]} />
        </td>;
      })}
    </tr>);

    return <table>
      <tbody>
        {rows}
      </tbody>
    </table>;
  }
}

function RateLabel(props) {
  const { rate, with_style } = props;
  return <span className={"label-rate" + (with_style ? ' with-style rate-' + rate : null)}><span className='label-rate-star'>{L('loc_dynamic_string_common_item_tier')}</span>{rate}</span>;
}

export function FirearmLabel(props) {
  const { firearm } = props;
  const { firearm_ty, firearm_name, firearm_rate, options } = firearm;
  const durability = firearm.durability ?? -1;
  const durability_text = durability >= 0 ? ` / LOC_TODO_내구도 ${durability}` : '';
  const options_text = options?.length > 0 ? options.join(' ') + ' ' : '';
  return <span className="item-label firearm-label"><RateLabel rate={firearm_rate} with_style={true} /> {options_text}{L(firearm_ty_name[firearm_ty])} / {L(firearm_name)}{durability_text}</span>;
}

export function GearLabel(props) {
  const { equipment } = props;
  const { vest_name, vest_armor, vest_rate, options } = equipment;
  const durability = equipment.durability ?? -1;
  const durability_text = durability >= 0 ? ` / LOC_TODO_내구도 ${durability}` : '';
  const options_text = options?.length > 0 ? options.join(' ') + ' ' : '';
  return <span className="item-label gear-label"><RateLabel rate={vest_rate} with_style={true} /> {options_text}{L(vest_name)} / {vest_armor}{durability_text}</span>;
}

export function ThrowableLabel(props) {
  const { throwable } = props;
  const { throwable_name, throwable_rate, options } = throwable;
  const durability = throwable.durability ?? -1;
  const durability_text = durability >= 0 ? ` / LOC_TODO_내구도 ${durability}` : '';
  const options_text = options?.length > 0 ? options.join(' ') + ' ' : '';
  return <span className="item-label throwable-label"><RateLabel rate={throwable_rate} with_style={true} /> {options_text}{L(throwable_name)}{durability_text}</span>;
}

function ItemBox2(ty, rate, name, detail, onClick, title) {
  const icons = {};
  icons['firearm'] = <svg xmlns="http://www.w3.org/2000/svg" width="200" height="100" viewBox="0 0 200 100" fill="none">
    <g filter="url(#filter0_d_467_2151)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M66.1933 38.1966C66.1933 38.1966 68.6619 33.9272 69.0563 30.2147L78.8816 27.9864L132.878 13.3509L134.229 11.1837L138.596 10L144 30.4022L110.59 39.4578L109.834 49.72C109.834 49.72 108.895 52.5693 107.111 53.0528L93.069 56.8588L91.8642 83.2441C91.8642 83.2441 91.4157 85.0101 89.7455 85.5235C89.7455 85.5235 77.8698 88.3243 67.9161 86.2109C67.9161 86.2109 66.1611 85.9064 65.9696 84.0638L69.2747 55.8022C69.2747 55.8022 68.2 52.6406 63.3818 51.3992L65.5387 45.5552C65.5387 45.5552 63.9107 41.3753 57 40.9444L57.4503 38.1397C57.4503 38.1397 62.2617 36.9923 66.1933 38.1966ZM94.6458 43.7721L92.9604 44.2289L93.0472 53.0437L103.875 50.093C105.608 49.4951 105.765 48.0228 105.765 48.0228L106.344 40.6013L98.2869 42.7852C99.5916 46.516 101.965 48.3321 101.965 48.3321L100.618 49.4959C97.6974 48.325 95.7522 45.7095 94.6458 43.7721Z" fill="#37311A"/>
    </g>
    <defs>
      <filter id="filter0_d_467_2151" x="50" y="3" width="101" height="91" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="3.5"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.533333 0 0 0 0 0.419555 0 0 0 0 0.248889 0 0 0 0.4 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_467_2151"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_467_2151" result="shape"/>
      </filter>
    </defs>
  </svg>;

  icons['equipment'] = <svg xmlns="http://www.w3.org/2000/svg" width="200" height="100" viewBox="0 0 200 100" fill="none">
    <g filter="url(#filter0_d_467_2234)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M71.2262 31.1813C71.2262 31.1813 74.752 12.219 88.805 10.2407C88.805 10.2407 100.082 7.7452 101.905 18.8244C101.905 18.8244 100.774 20.2416 99.6941 19.1626C99.6941 19.1626 97.4134 11.7018 93.3665 12.9612C93.3665 12.9612 83.7353 13.7448 81.7468 29.0704C81.7468 29.0704 80.9778 32.5601 83.0553 33.2004C89.5354 34.2216 96.1873 34.5038 103.042 34.2304C103.042 34.2304 106.422 12.246 120.818 11.7797C120.818 11.7797 130.004 11.4479 133.486 22.343C133.486 22.343 134.191 29.1414 133.95 38.089C133.95 38.089 133.39 62.9629 133.733 71.6881C133.733 71.6881 134.064 78.2049 132.584 79.8401C132.584 79.8401 121.783 89.3413 112.394 89.9151C112.394 89.9151 82.7822 91.3542 68.7039 82.3821C68.7039 82.3821 67.7064 82.2998 67.5285 79.2437L67.5158 69.6859C67.5158 69.6859 65.8069 68.9952 65.8704 67.8295L65 50.0719C65 50.0719 71.5055 52.7943 77.8776 53.1267V70.4727C77.8776 70.4727 79.8981 70.5116 82.0263 68.5886L81.8802 52.0238C81.8802 52.0238 80.4 50.4056 78.9007 50.2913C78.9007 50.2913 70.5019 49.7081 67.5096 47.4677C67.5096 47.4677 67.4079 40.0956 67.2999 34.3762C67.2999 34.3762 68.8184 32.9353 71.2262 31.1813ZM121.529 17.5783C121.529 17.5783 116.917 19.4648 115.278 26.6842C115.278 26.6842 113.836 37.4229 116.339 44.4713C116.339 44.4713 118.823 50.8267 125.659 50.3717C125.659 50.3717 130.487 49.3876 130.309 42.275C130.309 42.275 131.065 29.9508 130.176 23.9166C130.176 23.9166 128.492 15.0476 121.529 17.5783ZM69.3963 75.8294C69.3963 75.8294 69.0405 77.1937 69.4598 78.7127C69.4598 78.7127 86.7845 86.2029 107.711 85.3137C107.711 85.3137 113.086 84.9995 116.784 83.967C116.784 83.967 126.04 79.5956 131.453 75.8514C131.453 75.8514 131.853 74.4305 131.186 73.4125C131.186 73.4125 120.989 80.1147 116.288 81.1824C116.288 81.1824 110.392 82.7064 106.492 82.4707C106.492 82.4707 89.3321 83.7251 69.3963 75.8294ZM95.5901 51.753C95.7871 51.7907 93.1441 53.5377 92.1149 54.8386C92.1149 54.8386 104.668 56.0163 110.621 55.6103L110.983 75.0018C110.983 75.0018 114.255 73.3836 115.17 72.4214L114.751 54.5904C114.751 54.5904 113.791 52.0521 111.771 52.0917C106.238 52.1282 101.327 52.1621 95.5901 51.753Z" fill="#37311A"/>
    </g>
    <defs>
      <filter id="filter0_d_467_2234" x="58" y="3" width="83" height="94" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="3.5"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.533333 0 0 0 0 0.419555 0 0 0 0 0.248889 0 0 0 0.4 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_467_2234"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_467_2234" result="shape"/>
      </filter>
    </defs>
  </svg>;

  icons['throwable'] = <svg xmlns="http://www.w3.org/2000/svg" width="200" height="100" viewBox="0 0 200 100" fill="none">
    <g filter="url(#filter0_d_467_2249)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M70.7337 74.8313C70.7337 74.8313 61.8718 47.5822 84.2195 23.4903C84.2195 23.4903 93.8273 21.0639 99.8877 21.4C100.235 21.5216 101.822 12.8174 93.8266 12.6151C93.8266 12.6151 87.6839 12.9872 87.3985 19.9503L84.5914 20.1375C84.5914 20.1375 84.1428 8.80482 94.8414 9.00256C94.8414 9.00256 102.072 9.60503 103.541 16.356C103.541 16.356 107.471 14.4931 113.64 16.0977C113.64 16.0977 120.977 17.1757 123.887 22.8259L121.013 33.2377C121.013 33.2377 132.132 41.6385 129.945 56.8469C129.945 56.8469 120.313 65.3978 103.479 61.0186C103.479 61.0186 85.0273 55.8808 83.0157 46.5674C83.0157 46.5674 85.528 38.5644 92.8326 32.5601C92.8326 32.5601 96.7477 31.4184 98.4132 31.6368C98.4132 31.6368 111.412 39.0685 118.3 34.3147C118.3 34.3147 118.713 33.1211 116.808 33.4898C116.808 33.4898 107.942 34.8029 100.264 28.8564C100.264 28.8564 91.6509 29.5963 89.5467 30.1697C89.5467 30.1697 71.5853 43.8026 72.7802 75.5017L70.7337 74.8313ZM81.3187 50.5167C81.3187 50.5167 84.6326 60.1139 102.836 64.7301C102.836 64.7301 119.085 69.4405 129.62 60.547L131 61.6713L128.76 68.687C128.76 68.687 119.659 75.1846 108.266 73.385C107.576 73.276 107.882 74.1512 109.331 74.4875C112.798 75.293 120.222 76.3582 125.707 72.6758C125.707 72.6758 116.101 93.8773 94.7668 89.3716C94.7668 89.3716 80.2366 85.6358 77.6837 70.112C77.3661 68.2009 77.6454 63.8898 78.2749 61.5226C78.2749 61.5226 83.7523 66.3866 85.9602 66.0412C85.9602 66.0412 85.8149 65.3379 83.5702 63.725C83.5702 63.725 79.8957 60.5871 78.7546 58.857C78.7546 58.857 79.6769 53.8563 81.3187 50.5167Z" fill="#37311A"/>
    </g>
    <defs>
      <filter id="filter0_d_467_2249" x="62" y="2" width="76" height="95" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="3.5"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.533333 0 0 0 0 0.419555 0 0 0 0 0.248889 0 0 0 0.4 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_467_2249"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_467_2249" result="shape"/>
      </filter>
    </defs>
  </svg>;

  icons['resource'] = <svg xmlns="http://www.w3.org/2000/svg" width="200" height="100" viewBox="0 0 200 100" fill="none">
    <g filter="url(#filter0_d_467_2264)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M97.5005 74.7501L74.5344 71.3887L80.6642 59.6519L103.333 63.9021L103.551 53.518L88.7237 50.4554C85.6923 49.6999 82.6507 48.1022 80.1495 45.025C77.3 41.7407 75.9197 35.7807 76.7404 31.1706C78.2471 22.7014 85.3788 18.1902 91.1005 18.6982L97.5046 19.7339L97.5049 10.003L104.353 11.1616L104.353 20.8454L125.192 24.2289L119.916 35.093L97.5755 31.155L96.8211 40.331C100.993 41.0765 111.72 44.0005 113.287 44.8784C114.681 45.6565 116.437 46.5173 117.279 47.2148C122.195 51.2814 123.861 57.7597 122.693 63.6265C121.086 71.6974 113.333 77.3258 105.23 75.8777L104.349 75.7494L104.349 86.4476L97.4999 85.2889L97.5005 74.7501Z" fill="#37311A"/>
    </g>
    <defs>
      <filter id="filter0_d_467_2264" x="67.5344" y="3.00293" width="64.6576" height="90.4446" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="3.5"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.533333 0 0 0 0 0.419555 0 0 0 0 0.248889 0 0 0 0.4 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_467_2264"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_467_2264" result="shape"/>
      </filter>
    </defs>
  </svg>;

  icons['none'] = <svg xmlns="http://www.w3.org/2000/svg" width="200" height="100" viewBox="0 0 200 100" fill="none"></svg>

  return <div className={"item-box2 " + ty + "-box" + (onclick? ' item-box2-button' : null )} onClick={onClick ?? null}>
  <div className="item-box2-header">
    {rate ? <RateLabel rate={rate} with_style={true} /> : null}
    <div className="item-box2-name" title={title}>{name}</div>
  </div>
  {icons[ty]}
  <hr />
  <div className="item-box2-footer">{detail}</div>
</div>
}

export function FirearmBox(props) {
  const { selectable_reward, onClick, title } = props;

  let rate = 0;
  let name = '';
  let detail = '';
  if (selectable_reward) {
    const { value } = props;
    rate = value;
    name = L('loc_ui_string_result_reward_random') + L('loc_ui_string_common_firearm_full');
    detail = '';
  } else {
    const { firearm } = props;
    const { firearm_ty, firearm_name, firearm_rate, options } = firearm;
    const durability = firearm.durability ?? -1;
    const durability_text = durability >= 0 ? ` / LOC_TODO_내구도 ${durability}` : '';
    const options_text = options?.length > 0 ? options.join(' ') + ' ' : '';
    rate = firearm_rate;
    name = L(firearm_ty_name_short[firearm_ty]);
    detail = options_text + L(firearm_name) + durability_text;
  }

  return ItemBox2('firearm', rate, name, detail, (selectable_reward ? onClick : null), title);
}

export function GearBox(props) {
  const { selectable_reward, onClick, title } = props;

  let rate = 0;
  let name = '';
  let detail = '';
  if (selectable_reward) {
    const { value } = props;
    rate = value;
    name = L('loc_ui_string_result_reward_random') + L('loc_ui_string_common_equipment_full');
    detail = '';
  } else {
    const { equipment } = props;
    const { vest_name, vest_armor, vest_rate, options } = equipment;
    const durability = equipment.durability ?? -1;
    const durability_text = durability >= 0 ? ` / LOC_TODO_내구도 ${durability}` : '';
    const options_text = options?.length > 0 ? options.join(' ') + ' ' : '';
    rate = vest_rate;
    name = options_text + L(vest_name);
    detail = vest_armor + durability_text;
  }

  return ItemBox2('equipment', rate, name, detail, (selectable_reward ? onClick : null), title);
}

export function ThrowableBox(props) {
  const { selectable_reward, onClick, title } = props;

  let rate = 0;
  let name = '';
  let detail = '';
  if (selectable_reward) {
    const { value } = props;
    rate = value;
    name = L('loc_ui_string_result_reward_random') + L('loc_ui_string_common_throwable_full');
    detail = '';
  } else {
    const { throwable } = props;
    const { throwable_name, throwable_rate, options } = throwable;
    const durability = throwable.durability ?? -1;
    const durability_text = durability >= 0 ? ` / LOC_TODO_내구도 ${durability}` : '';
    const options_text = options?.length > 0 ? options.join(' ') + ' ' : '';
    rate = throwable_rate;
    name = L('loc_ui_string_common_throwable');
    detail = options_text + L(throwable_name) + durability_text;
  }

  return ItemBox2('throwable', rate, name, detail, (selectable_reward ? onClick : null), title);
}

export function CashBox(props) {
  const { selectable_reward, onClick, title } = props;

  let name = '';
  let detail = '';
  if (selectable_reward) {
    const { value } = props;
    name = L('loc_ui_string_common_resource');
    detail = '$' + value;
  } else {
    const { amount } = props;
    name = L('loc_ui_string_common_resource');
    detail = '$' + amount;
  }

  return ItemBox2('resource', null, name, detail, (selectable_reward ? onClick : null), title);
}

export function NoneBox(props) {
  const { selectable_reward, onClick, title } = props;

  return ItemBox2('none', null, L('loc_ui_button_result_reward_none'), '', (selectable_reward ? onClick : null), title);
}